import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'flash-messages-angular';
import { AdminService } from 'src/app/services/admin.service';
//import needs to be changed to new agencyService once completed
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-new-agency',
  templateUrl: './new-agency.component.html',
  styleUrls: ['./new-agency.component.css']
})

export class NewAgencyComponent implements OnInit {

  //Pattern
  phonePattern ="^((\\+91-?)|0)?[0-9]{10}$";

  agencyForm : any;
  // Agency Model
  agency = {
    agencyName: "",
    coordinatorName: "",
    email: "",
    phone: "",
    streetAddress: "",
    secondary: "",
    city: "",
    state: "",
    zipCode: "",
    county: "",
    isActive: true
  };

  constructor(private router: Router, private userService: UserService, private adminService: AdminService, private flashMessage: FlashMessagesService) { }

  ngOnInit(): void {
    console.log("component initialized")
  }

  // Submit Agency Information
  onSubmit() {
    this.adminService.addAgency(this.agency).toPromise().then((data: any) => {

      // Success
      if (data.success) {

        // Display success
        this.flashMessage.show("Successfully added agency.", {
          cssClass: 'alert-success',
          timeout: 3000
        });

        this.router.navigate(['/admin/home']);
      }

      // Error
      else {

        // Display error
        this.flashMessage.show(data.message, {
          cssClass: 'alert-danger',
          timeout: 3000
        });
      }
    });
  }
}
